export default __webpack_public_path__ + "static/media/f1.98db71b9.jpg";